import Swiper from "swiper/bundle";

const ProductMainSlider = () => {
  const productMainSlider = document.querySelector(".product-main__slider");

  if (productMainSlider) {
    const bigSlider = productMainSlider.querySelector(".big-product-slider");
    const smallSlider = productMainSlider.querySelector(".small-product-slider");
    
    const smallCarousel = new Swiper(smallSlider, {
      loop: true,
      spaceBetween: 8,
      slidesPerView: 5,
      freeMode: true,
      watchSlidesProgress: true,
      navigation: {
        nextEl: '.product-main__small-button-next',
        prevEl: '.product-main__small-button-prev',
      },
      breakpoints: {
        768: {
          spaceBetween: 12,
        },
      },
    });

    const bigCarousel = new Swiper(bigSlider, {
      slidesPerView: 1,
      effect: "fade",
      loop: true,
      thumbs: {
        swiper: smallCarousel,
      },
      navigation: {
        nextEl: '.product-main__big-button-next',
        prevEl: '.product-main__big-button-prev',
      },
    });
  }
};

export default ProductMainSlider;
